<template>
    <router-view
    ></router-view>
</template>

<script>
export default {
  name: "PoveznicaData",
    methods:{
    }
}
</script>

<style scoped>

</style>